<template>
  <vx-card title-color="primary" class="fill">
    <template slot="actions">
      <vs-dropdown style="margin-left: 15px">
        <a class="a-icon" href="#">
          Repositorio: <strong>{{ selectedRepository.nombreRepositorio }}</strong>
          <vs-icon class="" icon="expand_more"></vs-icon>
        </a>
        <vs-dropdown-menu>
          <vs-dropdown-item
            style="width:200px"
            v-for="repo in repositories"
            :key="repo.repositorioId"
            v-on:click.native="selectRepository(repo)"
          >
            {{ repo.nombreRepositorio }}
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </template>
    <filtros
      content-show
      content-field="content"
      ref="filtros"
      :configuracion-vista="configuration"
      :periodos="periodos"
      v-on:filtros-aplicados="handleFilters"
    />
    <div style="clear: both;border-bottom: solid 1px #ccc;margin-bottom: 10px"></div>
    <div v-if="firstSearch" class="message">
      Para realizar una búsqueda agrega algunos filtros y luego presiona el boton "Aplicar Filtros"
      arriba a la izquierda.
    </div>
    <div v-if="noResults" class="message">
      Oh no! no logramos encontrar nada con los filtros que ingresaste, verificalos o prueba
      quitando algunos.
    </div>
    <div v-if="loading" class="message">
      Buscando en el repositorio los elementos que coincidan con los filtros de busqueda
      ingresados...
    </div>
    <div v-for="item in result" v-bind:key="`object-${item.id}`" class="result">
      <div class="kind">
        <font-awesome-icon
          :icon="['fas', 'folder']"
          class="icon-folder"
          v-if="item.tipoObjeto === elementTipe.FOLDER"
        />
        <font-awesome-icon
          :icon="['fas', fileTypeIcon({mime:item.mime,name:item.nombre})]"
          :class="fileTypeIcon({mime:item.mime,name:item.nombre})"
          class="icon-file"
          v-if="item.tipoObjeto === elementTipe.FILE"
        />
      </div>
      <div class="detail">
        <div class="actions">
          <div class="action" v-if="item.tipo==='file'" v-on:click="download(item)">
            Descargar
            <font-awesome-icon :icon="['fas', 'download']" class="action-icon"/>
          </div>
          <div class="action" v-on:click="goTo(item)">
            Ver
            <font-awesome-icon :icon="['fas', 'arrow-right']" class="action-icon"/>
          </div>
        </div>
        <div class="name">{{ item.nombre }}</div>
        <div class="keywords"><span>Keywords:</span> {{ safeJoin(item.keywords, ", ") }}</div>
        <div class="tags"><span>Tags:</span>
          <div class="tag" v-for="tag in item.tags" v-bind:key="`tag-${tag}`">{{ tag }}</div>
        </div>
        <div class="ruta"><span>Ruta:</span>
          {{ item.path || '/' }}
        </div>
      </div>

    </div>
  </vx-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faFileImage, faFile, faFileVideo, faFileAudio, faFileCsv, faFileAlt,
  faFileArchive, faFilePdf, faFilePowerpoint, faFileExcel, faFileWord,
  faExclamationCircle, faCheckCircle, faCircle, faCalendar, faCalendarCheck,
  faCalendarTimes, faTimesCircle, faUserCircle, faFolder, faArrowRight, faDownload

} from '@fortawesome/free-solid-svg-icons';
import localForage from 'localforage';

import configFiltros from '@/febos/global/documentManagement/vistas/configFiltros';
import Filtros from '@/febos/global/_vue/componentes/Filtros';
import EDIcons from '@/febos/global/documentManagement/mixins/EDIcons';
import { ioFilesSearch } from '@/febos/servicios/api/busqueda.api';
import { DATE_RANGES } from '@/febos/chile/commons/dateCommons';

const elementTipe = {
  FILE: 1,
  FOLDER: 2
};

library.add(
  faFileImage,
  faFile,
  faFileVideo,
  faFileAudio,
  faFileCsv,
  faFileAlt,
  faFileArchive,
  faFilePdf,
  faFilePowerpoint,
  faFileExcel,
  faFileWord,
  faFolder,
  faExclamationCircle,
  faCheckCircle,
  faCircle,
  faCalendar,
  faCalendarCheck,
  faCalendarTimes,
  faTimesCircle,
  faUserCircle,
  faArrowRight,
  faDownload
);
export default {
  components: {
    Filtros
  },
  mixins: [EDIcons],
  data() {
    return {
      elementTipe,
      configuration: configFiltros,
      periodos: DATE_RANGES,
      repositories: [],
      selectedRepository: {},
      firstSearch: true, // true
      firstHandleFilters: true, // true
      result: [],
      loading: false
    };
  },
  watch: {
    loading(value) {
      if (value) {
        this.$vs.loading({ color: '#aaaaaa', text: 'Espera un momento por favor' });
      } else {
        this.$vs.loading.close();
      }
    }
  },
  computed: {
    ...mapGetters('DocManagement', [
      'getRepositories',
      'getSelectedElement',
    ]),
    showBackButton() {
      return document.referrer.endsWith('/repositorio');
    },
    noResults() {
      return !this.firstSearch && !this.loading && this.result.length === 0;
    },
    safeJoin() {
      return (data, joiner) => (data ? data.join(joiner) : '');
    }
  },
  methods: {
    ...mapActions('Modals', [
      'showModals',
      'closeModal'
    ]),
    ...mapActions('DocManagement', [
      'loadRepositories',
      'cleanTreeView',
      'setSelectedRepository'
    ]),

    async handleFilters(filtros) {
      if (this.firstHandleFilters) {
        this.firstHandleFilters = false;
      } else {
        if (this.firstSearch) {
          this.firstSearch = false;
        }
        this.loading = true;
        try {
          const payload = {
            repositoryId: this.selectedRepository.repositorioId,
            params: {
              elementosPorPagina: 1000,
              pagina: 1,
              filtros: `visualizadores:--usuario--,--grupos-y-padres--|repositorioId:${this.selectedRepository.repositorioId}|${filtros}`
            }
          };
          const response = await ioFilesSearch(payload);
          this.result = response.data.documentos;
        } finally {
          this.loading = false;
        }
      }
    },
    async setRepositoryList() {
      await this.loadRepositories();
      const repIds = Object.keys(this.getRepositories);
      for (let i = 0; i < repIds.length; i += 1) {
        if (i === 0) {
          this.selectedRepository = this.getRepositories[repIds[i]];
        }
        this.repositories.push(this.getRepositories[repIds[i]]);
      }
    },
    async download(item) {
      const storage = await localForage.getItem(process.env.VUE_APP_AMBIENTE);
      const fullPath = `${item.repositorioId}/${item.febosId}`;
      const dominio = 'archivos.escritoriodigital.cl';
      let url = `https://${dominio}/chile/${process.env.VUE_APP_AMBIENTE}/repositorios/${fullPath}`;
      const { token } = storage.Usuario;
      const empresa = storage.Empresas.empresa.empresaId;
      url += `?t=${token}&e=${empresa}`;
      window.open(url, '_blank');
    },
    async goTo(item) {
      const fullPath = `/${item.repositorioId}/${item.fullPath}`.replace('//', '/');
      const url = `repositorio#${fullPath}`;
      const newUrl = window.location.href.replace('repositorio/buscar', url);
      window.open(newUrl, '_blank');
    }
  },
  beforeMount() {

  },
  mounted() {
    this.setRepositoryList();
  },
  created() {
    this.result = [];
  }
};
</script>

<style lang="scss" scoped>
.message {
  border: solid 1px #ccc;
  border-radius: 5px;
  padding: 20px;
}

.kind, .detail {
  display: inline-block;
  min-height: 80px;
  vertical-align: top;

  & .icon-folder {
    color: orange;
    font-size: 55px;
  }

  & .icon-file {
    font-size: 55px;
    text-align: center;
    vertical-align: top
  }
}

.detail {
  width: calc(100% - 80px);
}

.name {
  font-size: 16px;
  font-weight: bold;
}

.kind {
  width: 60px;
  text-align: center;
  margin-right: 10px;
  padding-right: 10px;
  border-right: solid 1px #eee;
}

.result {
  padding: 10px;
  border-bottom: solid 1px #aaa;
  overflow-y: hidden;
}

.result:hover {
  background-color: #eee;
  cursor: pointer;
  box-shadow: 0 5px 5px -2px rgb(var(--vs-primary));

}

.actions {
  float: right;
  top: 5px;
  right: 10px;
}

.action {
  float: none;
  border: solid 1px rgb(var(--vs-primary));
  background-color: white;
  border-radius: 5px;
  display: inline-block;
  color: rgb(var(--vs-primary));
  margin-left: 5px;
  padding-left: 5px;
  padding-right: 5px;
}

.action:hover {
  cursor: pointer;
  background-color: rgb(var(--vs-primary));
  color: white;
}

.ruta, .tags span, .keywords span {
  color: #aaa;
  font-size: 11px;
}

.tag {
  background-color: rgb(var(--vs-primary));
  display: inline-block;
  color: white;
  margin-left: 5px;
  padding-left: 3px;
  padding-right: 3px;
  border-radius: 5px;
  font-size: 11px;
}
</style>
